<app-billing-header></app-billing-header>
 
<div class="content">
  <h2 class="mat-dialog-title custom-billing-heading">Dashboard</h2>
 
  <!-- Top Cards -->
  <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="32px" class="pricing-container card-container">
 
    <!-- Current Subscription Plan -->
    <mat-card class="pricing-card col-md-3">
      <mat-card-content>
        <h2 class="plan-title">Current Subscription Plan:</h2>
        <h3 class="plan-price">
          {{ getPlanName(user_current_subscription_plan) }}
        </h3>
        <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
      </mat-card-content>
    </mat-card>
 
    <!-- Subscription Start Date -->
    <mat-card class="pricing-card col-md-3">
      <mat-card-content>
        <h2 class="plan-title">Subscription Start Date:</h2>
        <h3 class="plan-price">
          {{ subscriptionStartDate ? getFormattedDate(subscriptionStartDate) : 'No Subscription Start Date' }}
        </h3>
        <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
      </mat-card-content>
    </mat-card>
 
    <!-- Subscription Renewal Date -->
    <mat-card class="pricing-card col-md-3">
      <mat-card-content>
        <h2 class="plan-title">Subscription {{will_cancel_at_end_of_period ? 'Cancel' : 'Renewal'}} Date:</h2>
        <h3 class="plan-price">
          {{ subscriptionEndDate ? getFormattedDate(subscriptionEndDate) : 'No Subscription auto-renew date' }}
        </h3>
        <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
      </mat-card-content>
    </mat-card>
 
    <!-- Total Listens -->
    <mat-card class="pricing-card col-md-3">
      <mat-card-content>
        <h2 class="plan-title">Total Current Period Listens:</h2>
        <h3 class="plan-price">
          {{ total_listeners}}
        </h3>
        <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
      </mat-card-content>
    </mat-card>
  </div>
  <!-- <mat-card appearance="outlined" class="example-card" style="margin-top:30px;">
		<mat-card-content>
			<p>As you exceed the volume tiers below, you will be automatically charged the difference. For example, once you past 10 listens to 11 listens, you will automatically be charged $40 (difference between $39.99 and $79.99)</p>
		</mat-card-content>
	</mat-card>
  <div class="my-show-table pricing-table">
    <div class="mat-elevation-z8 ex">
      <div class="billing-table">
        <table mat-table [dataSource]="pricingData" matSort   ="mat-elevation-z8 my-custom-table">
 
          <ng-container matColumnDef="listners_count">
            <th mat-header-cell *matHeaderCellDef> # Annual Listeners </th>
            <td mat-cell *matCellDef="let element"> {{element.listners_count | number:'1.0-2' }} </td>
          </ng-container>
          <ng-container *ngFor="let plan of subscriptionplansPlan" [matColumnDef]="plan.name">
                      <th 
              mat-header-cell 
              *matHeaderCellDef
              [ngClass]="{'': 
                  (hightlighted_row === 0 && plan.name === 'Hobbyist') ||
                  (hightlighted_row === 1 && plan.name === 'Professional')}">
              {{plan.name === 'hobbyist' ? 'Hobbyist' : 'Professional'}}
            </th>
            <td 
              mat-cell 
              *matCellDef="let element"
              [ngClass]="{'highlighted-column': 
                  (hightlighted_row === 0 && plan.name === 'hobbyist') ||
                  (hightlighted_row === 1 && plan.name === 'Professional')}">
              ${{ ((+plan.price) + (+element.total_price)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"[class.highlight-tier]="row.listners_count === currentTierCount && showDashboarddefaultMethod?.[0]?.subscription_plan != null"></tr>
        </table>
      </div>
    </div>
  </div> -->
</div>